import { Box, Grid } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'
const input = [{ label: 'label' }, { label: 'label' }, { label: 'label' }, { label: 'label' }, { label: 'label' }]

function SkeletonLoader() {
  return (
    <Box>
      {input.map((item, index) => (
        <div>
          <div style={{ display: 'flex' }}>
            <Skeleton variant="circle" width={45} height={45} style={{ paddingTop: '5px' }} />
            <div style={{ display: 'flex', flexDirection: 'column', padding: '5px' }}>
              <Skeleton variant="text" width={150} />
              <Skeleton variant="text" width={150} />
            </div>
          </div>
          <div
            style={{ width: '100%', marginTop: '10px', marginBottom: '10px', borderTop: '1px solid  #CCCCCC' }}
          ></div>
        </div>
      ))}
    </Box>
  )
}

export default SkeletonLoader
